<!-- 学校公告 -->
<template>
    <div class="fuzzy-matching-box">
        <!-- 公告管理 -->
    <div class="fuzzy-matching-top">
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="标题:">
            <el-input v-model="Dform.title" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="时间:">
              <el-date-picker
                  v-model="Dform.startDate"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="To:">
              <el-date-picker
                  v-model="Dform.endDate"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
        </el-col >
          <el-col :span="5">
          </el-col >
          <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
      </el-row>
      <!-- <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="学校:">
            <el-input v-model="Dform.schoolName" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="年级:">
            <el-input v-model="Dform.gradeName" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-col :span="5">
          <el-form-item label="班级:">
            <el-input v-model="Dform.className" placeholder=''></el-input>
          </el-form-item>
        </el-col >
          <el-col :span="5">
          </el-col >
      </el-row> -->
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
          stripe
          :border="true"
          v-loading="loading"
          :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="title"
            label="标题"
            width="150px"
            >
          </el-table-column>
          <el-table-column
            prop="content"
            label="公告范围"
            width="1000px"
            >
          </el-table-column>
            <el-table-column
            prop="createTime"
            label='时间'
            >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="发布人"
            >
          </el-table-column>
          <!-- <el-table-column
            prop="loginTime"
            label="操作"
            >
          </el-table-column> -->
          
        </el-table>

        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>
    </div>
  </template>
  
  <script>
  import { noticeManagement } from '@/assets/api/schoollog';
  export default {
    components: {
      
    },
    data() {
        return {
          loading:true,
          Dform:{
            className:"",
            endDate:"",
            gradeName:"",
            schoolName:"",
            startDate:"",
            title:"",
          },
          total:'',
          pageInfo:{
            pageSize:"3",
            page:"1",
          },
          tableData:[]
        };
    },
    created() {
      this.noticeManagementSearch()
    },
    mounted() {
  
    },
    methods: {
      noticeManagementSearch(){
        const params = {
          className:this.Dform.className,
          endDate:this.Dform.endDate,
          gradeName:this.Dform.gradeName,
          schoolName:this.Dform.schoolName,
          startDate:this.Dform.startDate,
          title:this.Dform.title,
          page:this.pageInfo.page,
          pageSize:this.pageInfo.pageSize,
          userId:JSON.parse(localStorage.getItem('user')).id,
        }
        noticeManagement(params).then((res)=> {
            // console.log(res.data.data.list,'校园公告成功');
            this.tableData = res.data.data.list
            this.total = res.data.data.total
            this.loading = false

        }).catch((err)=> {
          console.log(err,'校园公告失败');

        })
      },
      entrylogClick(){
        this.noticeManagementSearch()
      },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageInfo.page = val
      this.noticeManagementSearch()
    },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .fuzzy-matching-box {
    padding-top: 20px;
    // overflow: hidden;
    // overflow: auto;
    width: 100%;
    height:  96%;
    background-color: #fff;
    border-radius: 8px;
    .title-top {
        padding: 20px 20px;
    }
    .fuzzy-matching-top {
    height: 80px ;
    background-color: #fff;
    border-radius: 8px;
    .top-first-line {
      // justify-content: center 
      // justify-content: space-between
      justify-content: space-around;
      :deep() {
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }
        .el-select--small {
            width: 100%
        }
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;          
        }
        .el-input {
          width: 100%;
          height: 35px;
        }
      }
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        right: 300px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
      }
     
    }
    :deep() {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
      }
    }

  }
  .fuzzy-matching-bottom {
        // position: absolute;
        padding: 20px;
        :deep() {
          .el-table th.el-table__cell>.cell {
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 16px;
            font-weight: 700;
        }
        .el-table td.el-table__cell div{
          text-align: center;
          height: 150px;
          line-height: 40px;
          font-size: 16px;
          color: black;
        }
        .el-table:not(.el-table--border) .el-table__cell{
          border: 0;
        }
  } 
      .block-fenye{
        margin-left: 1000px;
        margin-top: 15px;
  }
}
        
}
  </style>
